module.exports = __webpack_public_path__ + "static/media/iaf.e7548699.webp";